import { FormatColorReset } from '@mui/icons-material';
import { serviceOpsInvoicingConstants } from '../../_constants';
import { goodsRowModel } from '../models';

const initialState = {
    data: '',
    invoicingInformation: {
        selectedCarrier: '',
        rows: [],
        
    },
};

export function serviceOpsInvoicing(state = initialState, action) {
    switch (action.type) {
        case serviceOpsInvoicingConstants.LOADING:
            switch (action.loader) {
                case 'initial':
                    return {
                        ...state,
                        loading: true

                    };
                case 'update':
                    return {
                        ...state,
                        tableUpdateLoading: true
                    };
            }

        case serviceOpsInvoicingConstants.ERROR:
            return {
                ...state,
                loading: false
            };

        case serviceOpsInvoicingConstants.SET_DATA_FROM_EXCEL:
            return {
                ...state,
                loading: false,
                data: action.data
            }

            case serviceOpsInvoicingConstants.UPDATE_INVOICING_ROW_VALUE:

                console.log(action.row)
                const editedRows = state.invoicingInformation.rows.map((x, index) =>
                    x.trackingId === action.row.trackingNumber && 
                    x.shipmentId === action.row.id ? {...x,totalPrice:parseFloat(action.row.actualPrice)}: x
                  )

                return {
                    ...state,
                    loading: false,
                    invoicingInformation: {
                        ...state.invoicingInformation,
                        rows: editedRows
                    }
                }

        case serviceOpsInvoicingConstants.UPDATE_INVOICING_TABLE:
         
            return {
                ...state,
                loading: false,
                tableUpdateLoading: false,
                invoicingInformation: {
                    ...state.invoicingInformation,
                    rows: action.data
                }
            };

            case serviceOpsInvoicingConstants.UPDATE_INVOICING_TABLE_AFTER_SAVE:

            const ids = action.data.map(x=> x.shipmentId)
            const newRows = state.invoicingInformation.rows.filter(obj => !ids.includes(obj.shipmentId));
         
            return {
                ...state,
                loading: false,
                tableUpdateLoading: false,
                invoicingInformation: {
                    ...state.invoicingInformation,
                    rows: newRows
                }
            };


        case serviceOpsInvoicingConstants.UPDATE_INVOICING_CARRIER_VALUE:
            return {
                ...state,
                loading: false,
                tableUpdateLoading: false,
                invoicingInformation: {
                    ...state.invoicingInformation,
                    selectedCarrier: action.data.value,
                    rows: state.invoicingInformation.rows
                }
            };

        default:
            return state
    }
}
